var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJdCe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 144,
    viewBox: "0 0 150 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2617_3381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.597 48.1499L111.597 94.6887L65.5957 120.835",
    stroke: "#FFEBAF",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.829 42.8833L106.829 89.4221L60.8271 115.568",
    stroke: "#FFEBAF",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.06 37.6169L102.06 84.1557L56.0581 110.302",
    stroke: "#FFEBAF",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.472 40.9353V56.5497L143.839 79.2196L149.401 75.1777C149.401 62.0863 142.641 49.8505 135.289 47.1409C134.597 31.561 124.195 8.22108 109.366 2.53714C100.378 -0.907819 92.3618 2.53717 88.3661 14.0038C78.6121 2.05327 66.3245 10.705 64.2573 23.7119L95.6888 51.1859L101.258 47.1409V31.1961L91.4495 25.321L109.866 14.511L121.757 36.7125L116.472 40.9353Z",
    fill: "#4A4141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.899 60.5977L143.827 79.2258C143.827 66.1344 137.068 53.8986 129.716 51.189C129.024 35.6091 118.622 12.2692 103.793 6.58521C94.8048 3.14026 87.6764 6.5851 83.674 18.5591C74.2584 7.8248 60.259 11.471 63.6558 32.9724L95.6851 51.189V35.2442L85.8764 29.3691L104.293 18.5591L116.184 40.7606L110.899 44.9834V60.5977Z",
    fill: "#FFD3B8",
    stroke: "black",
    strokeWidth: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5893 119.49L53.0329 113.129L40.1829 105.792L38.37 112.184C37.4602 115.391 35.3201 118.11 32.4156 119.747L26.877 122.87L46.981 134.394L48.6155 133.453C53.4917 130.646 55.9265 124.955 54.5893 119.49Z",
    fill: "#4A4141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7573 106.282L51.801 113.158L53.3018 119.292C54.5814 124.522 52.2513 129.968 47.5849 132.655L46.2212 133.44L27.2181 122.547L31.9234 119.894C34.9528 118.186 37.185 115.351 38.134 112.005L39.7573 106.282Z",
    fill: "#FFD3B8",
    stroke: "#092256",
    strokeWidth: 1.08768
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1172 123.447V122.498L46.24 133.888L47.1891 133.319V134.268L46.0501 135.027L26.1172 123.447Z",
    fill: "#4A4141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5933 127.244L36.7485 116.613C37.5648 115.377 38.0774 113.006 39.2164 109.019L52.505 116.613C54.1431 122.579 54.5984 125.262 54.5933 127.244Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0866 60.764L20.1306 16.7709C14.1531 13.3088 6.67041 17.622 6.67041 24.5298V81.4364C6.67041 84.6439 8.38376 87.6071 11.1636 89.2073L87.1195 132.93C93.0971 136.371 100.559 132.056 100.559 125.159V68.5229C100.559 65.3239 98.8547 62.3673 96.0866 60.764Z",
    fill: "#4A4141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5237 20.4141L90.5384 64.4333C93.0762 65.9029 94.6387 68.6133 94.6387 71.5459V128.217C94.6387 134.539 87.7991 138.494 82.3197 135.341L6.30499 91.5925C3.75649 90.1258 2.18567 87.4093 2.18567 84.4689V27.5267C2.18567 21.1948 9.04423 17.241 14.5237 20.4141Z",
    fill: "#FFD3B8",
    stroke: "black",
    strokeWidth: 1.49439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6515 65.1337L20.4845 27.7959C14.5363 24.4393 7.16908 28.7 7.11198 35.5297L6.71447 83.0724C6.68727 86.3255 8.42428 89.3381 11.2533 90.9444L77.8178 128.74C83.7951 132.134 91.2113 127.816 91.2113 120.943V72.9425C91.2113 69.7076 89.4688 66.7235 86.6515 65.1337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0646 26.6351L86.6619 65.0241C89.4673 66.6173 91.2005 69.5947 91.2005 72.8209V121.301C91.2005 128.165 83.8041 132.483 77.8269 129.11L10.2296 90.9569C7.41263 89.367 5.67041 86.3831 5.67041 83.1484V34.4319C5.67041 27.5579 13.0872 23.2406 19.0646 26.6351ZM21.3427 28.3228L86.2445 65.4823C89.0344 67.0798 90.7557 70.0486 90.7557 73.2635V120.074C90.7557 126.951 83.3323 131.268 77.3549 127.867L12.4532 90.9357C9.65154 89.3415 7.92126 86.3662 7.92126 83.1427V36.104C7.92126 29.2161 15.3652 24.9004 21.3427 28.3228Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2461 81.1021L62.6341 80.4403L21.0819 56.0441L20.6938 56.7002L62.2461 81.1021Z",
    fill: "#FFEBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8695 88.7244L62.2517 88.0682L35.1854 72.4356L34.8032 73.0974L61.8695 88.7244Z",
    fill: "#FFEBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4743 97.4878L61.8793 96.8431L48.5345 88.4562L48.1294 89.1009L61.4743 97.4878Z",
    fill: "#FFEBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0489 86.0601L42.4255 85.3982L34.4209 80.8225L34.0386 81.4843L42.0489 86.0601Z",
    fill: "#FFEBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6282 73.0972L63.0105 72.4354L45.0957 62.1429L44.7134 62.8047L62.6282 73.0972Z",
    fill: "#FFEBAF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2617_3381"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 149.4,
    height: 143.723,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJdCe);
export default __webpack_public_path__ + "static/media/jd-ce.45ebfb86f7b792fb2315a276e086d181.svg";
export { ForwardRef as ReactComponent };